import { Step } from "@/shared/interfaces/Step.interface";
import { validationClassified, updateClassified } from "@/shared/scripts/ValidateData";
import store from "@/shared/store";
import Vue from "vue";

export type StepsConfig = {
    steps: Step[],
    groups?: Step[],
}

export const getSteps = (): StepsConfig => ({
    steps: [
        {
            step: "step-property-type",
            label: "type_of_property",
            parent: "step-basic",
            beforeEnter: (stepname: string) => defaultBeforeEnter(stepname),
        },
        {
            step: "step-property-address",
            label: "address",
            parent: "step-basic",
            beforeEnter: (stepname: string) => defaultBeforeEnter(stepname)
        },
        {
            step: "step-pictures",
            label: "pictures",
            parent: "step-basic",
            beforeEnter: (stepname: string) => defaultBeforeEnter(stepname)
        },
        {
            step: "step-property-price",
            label: "price",
            parent: "step-basic",
            beforeEnter: (stepname: string) => defaultBeforeEnter(stepname)
        },
        {
            step: "step-general",
            label: "general",
            parent: "step-specification",
            beforeEnter: (stepname: string) => defaultBeforeEnter(stepname)
        },
        {
            step: "step-interior",
            label: "interior",
            parent: "step-specification",
            beforeEnter: (stepname: string) => defaultBeforeEnter(stepname)
        },
        {
            step: "step-exterior",
            label: "exterior",
            parent: "step-specification",
            beforeEnter: (stepname: string) => defaultBeforeEnter(stepname)
        },
        {
            step: "step-energy",
            label: "energy_performance",
            parent: "step-specification",
            beforeEnter: (stepname: string) => defaultBeforeEnter(stepname)
        },
        {
            step: "step-regulations",
            label: "regulations_and_permits",
            parent: "step-specification",
            beforeEnter: (stepname: string) => defaultBeforeEnter(stepname)
        },
        {
            step: "step-title-description",
            label: "title_and_description",
            beforeEnter: (stepname: string) => defaultBeforeEnter(stepname)
        },
        {
            step: "step-contact-information",
            label: "contact_information",
            beforeEnter: (stepname: string) => defaultBeforeEnter(stepname)
        },
        {
            step: "step-pricing",
            label: "pack_pricing",
            beforeEnter: (stepname: string) => defaultBeforeEnter(stepname),
            isDisabled: () => {
                return !store.getters["FormModule/hasErrors"] || (!store.getters["FormModule/getValidated"] && !store.getters["CustomersModule/getCurrentCustomer"]);
            }
        },
        {
            step: "step-payment",
            label: "payment",
            beforeEnter: (stepname: string) => defaultBeforeEnter(stepname),
            isDisabled: (): boolean => {
                return !store.getters["FormModule/hasErrors"] || !store.getters["OrdersModule/getCurrentOrder"] || !store.getters["PicturesModule/getPictures"]?.length;
            }
        },
    ],
    groups: [
        {
            step: "step-basic",
            label: "basic_information",
        },
        {
            step: "step-specification",
            label: "specification",
        },
    ]
});

export const getExtendSteps = (): StepsConfig => ({
    steps: [
        {
            step: "extend-choice",
            label: "pack_pricing",
        },
        {
            step: "extend-payment",
            label: "payment",
            isDisabled: (): boolean => {
                return !store.getters["OrdersModule/getCurrentOrder"];
            }
        },
    ]
});

export const getVisibilitySteps = (): StepsConfig => ({
    steps: [
        {
            step: "visibility-upgrade-choice",
            label: "visibility_upgrade"
        },
        {
            step: "visibility-upgrade-payment",
            label: "payment",
            isDisabled: (): boolean => {
                return !store.getters["OrdersModule/getCurrentOrder"];
            }
        }
    ]
});

function defaultBeforeEnter(stepName: string): void {

    if (store.getters["FormModule/getIsEditionMode"]){
        validationClassified(() => {            
            Vue.prototype.routeToPage(stepName);
        });
    } else {
        updateClassified(() => {
            Vue.prototype.routeToPage(stepName);
        });
    }
}
